import { PlaceholderPage } from './PlaceholderPage';

/**
 * /admin/finance — Finance team surface for the `nexa_finance` business role
 * (ADR-075). Placeholder shell (ADR-036 PlaceholderPage). The Finance
 * permission catalogue is stubbed at the staff-Cedar cutover — `nexa_finance`
 * default-denies every existing gated action, and `nexa_admin` reaches this
 * area transitionally until the catalogue is designed. Real implementation
 * lands when the Finance surface is locked into a reference doc + ADR.
 */
export function FinancePage() {
  return (
    <PlaceholderPage
      title="Finance"
      plannedPhase="Phase 6+"
      intent={
        <>
          The Finance team surface — the home of the <code>nexa_finance</code>{' '}
          business role introduced with the staff Cedar AAA migration (ADR-075).
          Finance covers subscription revenue, billing reconciliation, plan and
          tier economics, vendor-cost tracking, and dunning / collections. Access
          is governed by the <code>finance:read</code> Cedar action; the detailed
          permission catalogue is designed in a follow-up, so this area is a stub
          today (<code>nexa_admin</code> reaches it transitionally).
        </>
      }
      features={[
        'Subscription revenue (MRR / ARR) and movement reporting',
        'Billing reconciliation and invoice status',
        'Plan / tier economics and vendor-cost tracking',
        'Dunning and collections worklist',
        'Finance-scoped role (nexa_finance) with its own permission catalogue',
      ]}
    />
  );
}
